import { combineReducers } from '@reduxjs/toolkit';
import basicInformationSlice from './slices/basicInformationSlice';
import userDetailsSlice from './slices/userDetailsSlice';
import requestorDetailsSlice from './slices/requestorDetailsSlice';

const rootReducer = combineReducers({
    basicInformationSlice: basicInformationSlice,
    userDetailsSlice: userDetailsSlice,
    requestorsSlice:requestorDetailsSlice
});

export default rootReducer;
